import styled from "styled-components"
import { Box } from "../../../components/elements"
import { ContactButton, Disclaimers, PRSection, Title } from "./components"

import { useEffect } from "react"
import { devices } from "../../../themes/theme"

interface IResultLayoutProps {
  children: React.ReactNode
  disclaimers: string[]
}

const Container = styled(Box)`
  background-color: ${(props) => props.theme.colors.bodyBackground};
`

const Section = styled.section`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding-block-start: clamp(2rem, 1.2rem + 4vw, 6rem);
  padding-inline: clamp(1.5rem, 0.5rem + 5vw, 6.5rem);
  padding-block-end: 2rem;
  @media ${devices.mobile} {
    padding-block-end: clamp(2rem, 1.2rem + 4vw, 6rem);
  }
  background-color: ${(props) => props.theme.colors.boxBackground};
  width: 100%;
`

const ResultLayout = (props: IResultLayoutProps) => {
  const { children, disclaimers } = props
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container flexDirection="column" fullwidth>
      <Section>
        <Title />
        {children}

        <Disclaimers textList={disclaimers} />
        <ContactButton />
      </Section>

      <PRSection />
    </Container>
  )
}
export { ResultLayout }
